import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
  KeyboardAvoidingView,
} from "react-native";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import TextInput from "app/components/TextInput";
import chapterActions from "app/utils/chapterActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
} from "app/utils/styleSheet";

import Chapter from "app/components/Chapter";
import MomentList from "app/components/chapter/MomentList";
import ScratchPad from "app/components/ScratchPad";

import store from "app/redux/store";

import {
  Ionicons,
  Octicons,
  FontAwesome,
  FontAwesome5,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class ChapterView extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    let { navigation, route } = this.props;
    let id = route?.params?.id;
    let chapter = route?.params?.chapter || {
      title: " ",
      start_at: undefined,
      end_at: undefined,
      moment: [],
      values: [],
    };
    this.state = {
      id,
      loading: true,
      autoCreate: true,
      chapter,
      loadingActivity: false,
    };
  }

  async componentDidMount() {
    this.fetchChapter();
  }

  fetchChapter = async () => {
    let { chapter, id } = this.state;
    if (!chapter?.id && !id) return;
    let chapterId = chapter?.id || id;
    await this.setState({ loading: true });
    let res = await chapterActions.show(chapterId);
    if (res?.success) {
      console.log("fetch chapter res", res);
      this.setState({ chapter: res.chapter, loading: false });
    } else {
      this.setState({ loading: false });
      if (!!res?.error?.length) {
        alert(res.error);
      }
    }
  };

  render() {
    let {
      loading,
      chapter,
      autoCreate,
      showAllActivity,
      loadingActivity,
      allMoments,
    } = this.state;

    let renderChapComp = true;

    return (
      <View
        enabled={false}
        behavior={"padding"}
        // keyboardShouldPersistTaps={"handled"}
        keyboardShouldPersistTaps={"always"}
        style={this.styles().container}
        // keyboardVerticalOffset={isIphoneX() ? (fontVars.landingHeaderSize + 20) : fontVars.landingHeaderSize + Math.max(0, (Constants.statusBarHeight-20))}
        // keyboardVerticalOffset={60}
      >
        {/*<View style={this.styles().container}>*/}
        <StatusBar style="auto" />

        {/*<View />*/}
        <ScrollView nestedScrollEnabled keyboardShouldPersistTaps={"always"}>
          {renderChapComp && (
            <View style={this.styles().chapCompWrapper}>
              <Chapter chapter={chapter} />
            </View>
          )}

          <View style={this.styles().content}>
            <View style={[this.styles().row, this.styles().headerRow]}>
              <Text>{chapter.title}</Text>
            </View>
            {loading ? (
              <ActivityIndicator />
            ) : (
              <View
                style={{
                  marginBottom: this.context.sizes.large,
                  padding: this.context.sizes.large,
                  borderWidth: 1,
                  borderRadius: this.context.sizes.borderRadius,
                  borderColor: this.context.colors.trim,
                }}
              >
                <ScratchPad
                  chapter={chapter}
                  references={chapter.references}
                  ref={(r) => (this.scratchPadRef = r)}
                  onUpdateText={(text) =>
                    this.setState({ chapter: { ...chapter, text } })
                  }
                  focusNext={this.momentList?.handleFocusFirstMoment}
                  // focusPrevious={this.handleFocusTitle}
                  inline
                  // showActions={false}
                />
              </View>
            )}
            <MomentList
              ref={(ref) => (this.momentList = ref)}
              atemporal
              autoCreate={autoCreate}
              chapterId={chapter?.id}
              chapter={chapter}
              moments={chapter.moments}
              values={chapter.values}
              // expanded={true}
              onUpdateMoments={(moments) => {
                console.log("on update moments", moments);
                this.setState({ chapter: { ...chapter, moments } });
              }}
              onUpdateChapter={async (chapter) => {
                console.log("on update chapter!", chapter);
                await this.setState({ chapter, autoCreate: false });
              }}
              onAddChild={(value) => {
                this.setState({
                  chapter: {
                    ...chapter,
                    moments: [
                      ...chapter.moments,
                      { value_id: value.id, value },
                    ],
                    values: [...chapter.values, value],
                  },
                });
              }}
              onFocusChapterTitle={() => {
                if (!!this.scratchPadRef) {
                  this.scratchPadRef.focus(9999);
                }
              }}
              // autoCreate={autoCreate}
              // onExpand={() => this.setState({ expanded: true })}
              // onCollapse={() => this.setState({ expanded: false })}
            />

            <View style={this.styles().row}>
              <View />
              {chapter.range > 1 && (
                <Text
                  button
                  onPress={this.fetchActivity}
                  disabled={loadingActivity}
                >
                  {showAllActivity ? "Hide" : "Show"} All Activity{" "}
                  {loadingActivity && <ActivityIndicator size="small" />}
                </Text>
              )}
            </View>

            {showAllActivity && (
              <MomentList
                // ref={(ref) => (this.momentList = ref)}
                atemporal
                // autoCreate={autoCreate}
                chapterId={chapter?.id}
                rootChapter={chapter}
                chapter={chapter}
                moments={allMoments}
                values={chapter.values}
                // onUpdateMoments={(moments) => {
                //   console.log("on update moments", moments);
                //   this.setState({ chapter: { ...chapter, moments } });
                // }}
                // onUpdateChapter={async (chapter) => {
                //   console.log("on update chapter!", chapter);
                //   await this.setState({ chapter, autoCreate: false });
                // }}
                // onAddChild={(value) => {
                //   this.setState({
                //     chapter: {
                //       ...chapter,
                //       moments: [
                //         ...chapter.moments,
                //         { value_id: valud.id, value },
                //       ],
                //       values: [...chapter.values, value],
                //     },
                //   });
                // }}
                // onFocusChapterTitle={() => {
                //   if (!!this.scratchPadRef) {
                //     this.scratchPadRef.focus(9999);
                //   }
                // }}
                chapterMoments={allMoments}
                nestPinnedChildren
                hideScrathpadPreview
              />
            )}
          </View>
        </ScrollView>
      </View>
    );
  }

  fetchActivity = async () => {
    let { chapter, id, showAllActivity } = this.state;
    let chapterId = chapter?.id || id;
    if (!chapterId) return;
    if (showAllActivity) {
      this.setState({ showAllActivity: false });
      return;
    }
    await this.setState({ loadingActivity: true });
    let res = await chapterActions.allActivity(chapterId);
    if (res?.success) {
      console.log("all activity res", res);
      let moments = res.moments;
      if (res.additional_values) {
        moments = [
          ...res.additional_values.map((v) => ({ value: v })),
          ...moments,
        ];
      }
      this.setState({
        showAllActivity: true,
        loadingActivity: false,
        allMoments: res.moments,
      });
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      // justifyContent: "space-between",
      justifyContent: "stretch",
    },
    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      margin: this.context.sizes.large,
    },
    headerRow: {},
    chapCompWrapper: {
      marginTop: this.context.sizes.large,
      marginLeft: this.context.sizes.large,
    },
    content: {
      // alignSelf: "center",
      justifyContent: "stretch",
      // borderWidth: 1,
      minWidth: 500,
      minHeight: 400,
      padding: this.context.sizes.giant,
      // justify
    },
  });
}
